<template>
   <v-btn class="back" icon @click.prevent="back()">
      <v-icon>keyboard_backspace</v-icon>
   </v-btn>
</template>
<script>
export default {
    methods : {
      back(){
         if(this.$routerHistory.hasPrevious())
            this.$router.go(-1);
         else
            window.location.href=`https://jujue.app/browser`
      }
    }
}
</script>
<style scoped>
 .back {
    float:left;
 }
</style>

